export const SELLING_PROPERTY_TYPE_OPTIONS = [
  { value: 'exclusive', label: 'Exclusive' },
  { value: 'not exclusive', label: 'Not exclusive' },
  { value: 'cooperation', label: 'Cooperation' }
];

export const SELLING_PROPERTY_REAL_ESTATE_TYPE_OPTIONS = [
  { value: 'nepozidano stavbno zemljišče', label: 'Nepozidano stavbno zemljišče' },
  { value: 'stanovanje', label: 'Stanovanje' },
  { value: 'hiša', label: 'Hiša' },
  { value: 'kmetijsko zemljišče', label: 'Kmetijsko zemljišče' },
  { value: 'gozd', label: 'Gozd' }
];

export const normalizeSellingPropertyType = (value) => {
  if (typeof value !== 'string') return '';

  const trimmed = value.trim();
  if (!trimmed) return '';

  const normalized = trimmed.toLowerCase();
  if (normalized === 'exclusive') return 'exclusive';
  if (normalized === 'not exclusive' || normalized === 'not_exclusive' || normalized === 'notexclusive') return 'not exclusive';
  if (normalized === 'cooperation' || normalized === 'co-operative' || normalized === 'cooperative') return 'cooperation';

  return trimmed;
};

export const getSellingPropertyTypeLabel = (value) => {
  const normalized = normalizeSellingPropertyType(value);
  const option = SELLING_PROPERTY_TYPE_OPTIONS.find((entry) => entry.value === normalized);
  return option ? option.label : normalized;
};
